import { oz } from '@weft/utils';
import { PerUnitPricingSchema } from './per-unit/per-unit-pricing-schema';
import { TieredSubscriptionPricingSchema } from './tiered-subscription/tiered-subscription-pricing-schema';
import { TiersPricingSchema } from './tiers/tiers-pricing-schema';

export const UsagePricingSchema = oz.discriminatedUnion('pricingModel', [
  PerUnitPricingSchema,
  TiersPricingSchema,
  TieredSubscriptionPricingSchema,
]).openapi('UsagePricing');

export type UsagePricing = oz.infer<typeof UsagePricingSchema>;